import {Component}       from '@angular/core';
import {FormsModule}     from '@angular/forms';
import {UiLogoComponent} from '../../../logr-ui/comps/ui/ui-logo/ui-logo.component';

@Component({
			   selector   : 'app-auth-wrapper',
			   imports    : [
				   FormsModule,
				   UiLogoComponent
			   ],
			   templateUrl: './auth-wrapper.component.html',
			   styleUrl   : './auth-wrapper.component.css'
		   })
export class AuthWrapperComponent {

}
